import {
    Component,
    OnInit,
    ElementRef,
    ViewChild,
    AfterViewInit,
} from '@angular/core'
import { AuthService, LoginPayload } from '../../services/login/auth.service'
import {
    Validators,
    FormsModule,
    ReactiveFormsModule,
    FormBuilder,
} from '@angular/forms'
import { TokenSession } from '../../models/users.interface'
import { Router } from '@angular/router'
import { catchError, switchMap } from 'rxjs'
import { jwtDecode } from 'jwt-decode'
import { NgIf } from '@angular/common'
import { Title } from '@angular/platform-browser'
import { MatCard } from '@angular/material/card'
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { DecodedToken } from '../../models/auth.interface'
import { ProfileService } from '../../services/profile/profile.service'
import { LayoutService } from '../../services/layout/layout.service'

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgIf,
        MatError,
        MatFormField,
        MatLabel,
        MatCard,
        MatCard,
        FormsModule,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        NgIf,
        MatError,
    ],
})
export class LoginComponent implements OnInit, AfterViewInit {
    @ViewChild('googleButton', { static: false }) googleButton!: ElementRef
    //se instancia el estado del formulario y sus validaciones por campo
    loginForm = this.fb.group({
        username: ['', [Validators.required, Validators.minLength(4)]],
        password: ['', [Validators.required, Validators.minLength(4)]],
    })

    userSession: TokenSession | null = null
    errorMsg: string | null = null

    constructor(
        private authService: AuthService,
        private fb: FormBuilder,
        private router: Router,
        private title: Title,
        private perfilService: ProfileService,
        private layoutService: LayoutService
    ) {
        this.title.setTitle('Inicio de sesión')
    }
    ngOnInit(): void {
        this.authService.errorMsg$.subscribe((msg) => (this.errorMsg = msg))
        const token = localStorage.getItem('token')
        if (token) {
            this.router.navigate(['home'])
        }
    }

    ngAfterViewInit(): void {
        this.authService.initializeGoogleSignIn().then(() => {
            if (this.googleButton) {
                this.authService.renderGoogleButton(
                    this.googleButton.nativeElement
                )
            }
        })
    }

    onSubmit() {
        //si los datos ingresados son validos se ejecuta el request
        if (this.loginForm.status === 'VALID') {
            //el casting es valido ya que los validators del form se encarga de que no sea undefined o null
            this.authService
                .login(this.loginForm.value as LoginPayload)
                .pipe(
                    catchError((error) => {
                        this.authService.setError(
                            'El usuario o la contraseña no se encontraron'
                        )
                        return []
                    }),
                    switchMap((response) => {
                        if (response) {
                            localStorage.setItem(
                                'token',
                                JSON.stringify(response)
                            )
                            this.authService.setToken(response)
                            const decodedToken: DecodedToken = jwtDecode(
                                response.access
                            )
                            return this.perfilService.getOneProfile(
                                String(decodedToken.user_id)
                            )
                        }
                        return []
                    }),
                    switchMap((profile) => {
                        if (profile) {
                            this.perfilService.setUserProfile(profile)
                            this.authService.setError(null)
                            this.router.navigate(['home'])
                            this.layoutService.genMenuLinks(profile)
                        }
                        return []
                    })
                )
                .subscribe()
        }
    }

    ngOnDestroy() {
        this.layoutService.setShowMenu(true)
    }
}
